/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdministration = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="currentcolor">
      <path d="M7 15h2v3H7zm8 0h2v3h-2zm-4 0h2v3h-2z" />
      <path d="M13 9.1V7h5V2h-7v7.1c-4.5.5-8 4.3-8 8.9v4h18v-4c0-4.6-3.5-8.4-8-8.9zM13 4h3v1h-3zm6 16H5v-2c0-3.9 3.1-7 7-7s7 3.1 7 7z" />
    </g>
  </Icon>
);
export { SvgAdministration as Administration };
